import LandingPage from "../LandingPage.jsx";

export default function LandingEs() {
  return <LandingPage forcedLang="es" />;
}